import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import InputCheck from "core/input-check/InputCheck";
import "./MissionRTTForm.scss";

const MissionRTTForm = ({ readOnly, setValue, watch }) => {
  return (
    <div className="section-rtt">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={<FormattedMessage id="other" defaultMessage="autre" />}
      />
      <InputCheck
        readOnly={readOnly}
        value={watch("sale_toil_authorized")}
        setValue={(val) => setValue("sale_toil_authorized", val)}
        label={{ id: "rtt", defaultMessage: "Vente RTT autorisée" }}
      />
    </div>
  );
};

export default MissionRTTForm;
